module.exports = __webpack_public_path__ + "static/media/user_7.27bb204c.png";